import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { UserInterfaceService } from '../../services/user-interface.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit, OnDestroy {

  darkTheme: Boolean = false;
  darkThemeSubscription: Subscription;

  authentication: boolean = false;
  authSubscription: Subscription;

  constructor(private userInterfaceService: UserInterfaceService, private authService: AuthService) { }

  ngOnInit() {
    this.darkThemeSubscription = this.userInterfaceService.getDarkTheme().subscribe(result=>{
      this.darkTheme = result;
    });

    this.authSubscription = this.userInterfaceService.getAuthentication().subscribe(result=>{
      this.authentication = result;
    });
 
  }

  ngOnDestroy(): void {
    this.darkThemeSubscription.unsubscribe();
  }


}
